import { removeClass, addClass } from '@utils/domUtils';
import { post } from '@utils/request';

/* global ACTION_ROUTES */

export default class Rating {
  static selectorString() {
    return '.Rating';
  }

  render(node, props) {
    this.rating = props.rating;

    node.addEventListener('mousemove', this.displayStars.bind(this));
    node.addEventListener('mouseout', this.resetRating.bind(this));
    node.addEventListener('click', this.saveRating.bind(this));

    this.stars = [...node.querySelectorAll('.star')];
  }

  getRating(event) {
    const percentage =
      (event.pageX + 6 - this.node.getBoundingClientRect().left) / (this.node.offsetWidth - 20);
    const rating = percentage * 5;
    const normalizedRating = Math.round(rating * 2) / 2;

    return Math.max(0, Math.min(5, normalizedRating));
  }

  displayStars(event) {
    const rating = this.getRating(event);
    this.renderRating(rating);
  }

  renderRating(rating) {
    const hasHalfRating = Math.ceil(rating) - Math.floor(rating) === 1;

    this.stars.forEach((star, index) => {
      if (hasHalfRating && Math.ceil(rating) === index + 1) {
        removeClass(star, 'text-muted');
        addClass(star, 'text-warning');
        addClass(star, 'fa-star-half-alt');
        removeClass(star, 'fa-star');
      } else if (rating > index) {
        removeClass(star, 'text-muted');
        addClass(star, 'text-warning');
        removeClass(star, 'fa-star-half-alt');
        addClass(star, 'fa-star');
      } else {
        addClass(star, 'text-muted');
        removeClass(star, 'text-warning');
        removeClass(star, 'fa-star-half-alt');
        addClass(star, 'fa-star');
      }
    });
  }

  resetRating() {
    this.renderRating(this.rating);
  }

  saveRating(event) {
    if (this.isSubmitting) {
      return;
    }

    this.isSubmitting = true;

    const rating = this.getRating(event);
    const initialRating = this.rating;
    this.rating = rating;

    post({
      url: ACTION_ROUTES.RATE_APPLICATION,
      data: {
        rating: rating,
        applicationId: this.props.application,
      },
      success: () => {
        this.rating = rating;
        this.isSubmitting = false;
        this.renderRating(this.rating);
      },
      error: () => {
        this.rating = initialRating;
        this.isSubmitting = false;
        this.renderRating(this.rating);
      },
    });
  }
}
